<template>
  <section class="instagram_section" v-if="instagramPosts.length">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="insta_title">
            <h5><img src="@/assets/images/Instagram_icon.svg" alt="Instagram_icon.svg"> Instagram</h5>
          </div>
        </div>
      </div>

      <div class="instagram_slider">
        <ul>
          <VueSlick v-bind="slickSettings">
            <li v-for="post in instagramPosts" :key="post.id">
              <div class="insta_images">
                <a href="https://www.instagram.com/gmnanashi/" target="_blank">
                  <img :src="post.media_url" alt="insta_1.svg">
                </a>
              </div>
            </li>
          </VueSlick>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default{
  name: 'InstagramFeed',
  data () {
    return {
      slickSettings: {
        dots: false,
        infinite: false,
        arrows: false,
        swipeToSlide: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        draggable: true,
        autoplay: false,
        autoplaySpeed: 1500,
        variableWidth: false,
        centerMode: false,
        fade: false,
        cssEase: 'linear',
        responsive: [{
          breakpoint: 1200,
          settings: {
            slidesToShow: 5
          }
        },

        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4
          }
        },

        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 2
          }
        }
        ]
      },
      instagramPosts: []
    }
  },
  mounted () {
    this.fetchInstagramFeed()
  },
  methods: {
    fetchInstagramFeed () {
      this.$store
        .dispatch('fetchInstagramFeed')
        .then((resp) => {
          this.instagramPosts = resp.data.posts
        })
        .catch((err) => this.$helper.catchHandler(err))
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/InstagramFeed.vue